import { render } from "./AdornosRestantes.vue?vue&type=template&id=2a1947bc"
import script from "./AdornosRestantes.vue?vue&type=script&lang=js"
export * from "./AdornosRestantes.vue?vue&type=script&lang=js"

import "./AdornosRestantes.vue?vue&type=style&index=0&id=2a1947bc&scope=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__